import di from 'di'

import axios from 'axios'

export default function(){

    di.factory('http', () => {

        const config = di.get('config');

        const http = axios.create({
            baseURL: config.apiUrl
        });

        return http;
    });
}